
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ConsumerDebtSettlementPage from '../pages/consumer-debt-settlement/page';
import BusinessDebtReliefPage from '../pages/business-debt-relief/page';
import ResourcesPage from '../pages/resources/page';
import FAQPage from '../pages/faq/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/consumer-debt-settlement',
    element: <ConsumerDebtSettlementPage />,
  },
  {
    path: '/business-debt-relief',
    element: <BusinessDebtReliefPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
